import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: rgba(200, 19, 27, 0.1);
  white-space: nowrap;

  ${(props) =>
    props.type === 'accepted' &&
    css`
      background: #fff8eb;
    `}

  ${(props) =>
    props.type === 'ready' &&
    css`
      background: #fff2ea;
    `}

  ${(props) =>
    props.type === 'ongoing' &&
    css`
      background: #e6f7ff;
    `}
`;
export const Title = styled.span`
  font-size: 12px;
  font-weight: bold;
`;
export const Time = styled.span`
  font-size: 12px;
`;
